import Api from "@/services/Index";

const store = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/exam/definitions", formData);
};

const calculate = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/exam/scores/calculate/" + id);
};
const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/exam/definitions", config);
};
const get = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/exam/definitions/" + id);
};
const put = async (id, formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put("/exam/definitions/" + id, formData);
};
const deletes = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete("/exam/definitions/" + id);
};
const getStudents = async (sectionId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get(`sections/${sectionId}/students`);
};
const examScores = async (examId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get(`exam/scores?exam_id=${examId}`);
};
const examScoreSave = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post(`exam/scores`, data);
};
const examPublish = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get(`exams/publish/` + id);
};
const exams = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get(`/exams`,config);
};

const getExamScore = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;

    return Api.get(`exam/scores`, config);
};
const saveExamPublish = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get(`/exams/publish/${id}`);
};
const sectionGrades = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get(`/sections/${id}/grades`);
};
const updateSectionGrade = async (id,data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put(`/sections/${id}/update-section-grades`,data);
};
const calculateExams = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post(`/student/courses/calculate-grades/${id}`);
};


export default {
    store,
    getAll,
    get,
    put,
    deletes,
    getStudents,
    examScores,
    examScoreSave,
    examPublish,
    calculate,
    exams,
    getExamScore,
    saveExamPublish,
    sectionGrades,
    updateSectionGrade,
    calculateExams
};
